
const genderTypeEnum = {
 MALE: "Male",
 FEMALE: "Female",
}

export default genderTypeEnum;

